<template>
    <div>
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">Тасагт хийх эмчилгээ үйлчилгээ болон анхаарах зүйлс</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">Бэлдэх зүйлс</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">Эмчийн үзлэг</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">Хоолны заавар</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">Эргэлтийн заавар болон анхаарах зүйлс</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">Бусад</a>
                </li>
            </ul>
        </div>

        <!-- 대동맥 -->
        <div class="subSwiper info" v-if="$store.getters.getHost == 'H0006'">
            <swiper 
                :cssMode="true" 
                :navigation="{
                    nextEl: '.subSwiper-next',
                    prevEl: '.subSwiper-prev'
                }" 
                :pagination="{ clickable: true }" 
                :mousewheel="true" 
                :keyboard="true" 
                :modules="modules"
            >
                <swiper-slide>
                    <img src="/resource/img/info-img05.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img06.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img07.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img08.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <!-- 뇌혈관 -->
        <div class="subSwiper info" v-else>
            <swiper 
                :cssMode="true" 
                :navigation="{
                    nextEl: '.subSwiper-next',
                    prevEl: '.subSwiper-prev'
                }" 
                :pagination="{ clickable: true }" 
                :mousewheel="true" 
                :keyboard="true" 
                :modules="modules"
            >
                <swiper-slide>
                    <img src="/resource/img/hospitalization01-brain.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/hospitalization02-brain.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/hospitalization03-brain.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <div id="step1" class="step-item info">
            <h3 class="bullet01">Тасагт хийх эмчилгээ үйлчилгээ болон анхаарах зүйлс</h3>
            <h4 class="bullet02 type2 num1 depth">Яаралтай үед дуудах арга </h4>
            <p class="depth">
                Яаралтай нөхцөл байдалд, мөн сувилагчийн тусламж хэрэгтэй үед орны хажууд эсвэл 00-н өрөө, шүршүүрийн өрөөний хананд буй яаралтай тусламжийн хонхыг дарж тэр даруй тусламж авах боломжтой.    
            </p>

            <h4 class="bullet02 type2 num2 depth">Бугуйвч зүүх</h4>
            <p class="depth">
                Өвчтөнүүдийг тодорхой ялгахын тулд бугуйвч зүүх хэрэгтэй бөгөөд үүгээр дамжуулан өвчтөний нэр болон бүртгэлийн дугаарыг шалгадаг. Бугуйвч бохирдсон эсвэл гэмтсэн тохиолдолд сувилагчийн өрөө рүү мэдэгдэнэ үү. Бид нэн даруй сольж өгөх болно.  
            </p>

            <h4 class="bullet02 type2 num3 depth">Хүүхэд алга болох болон барьцаалагдахаас урьдчилан сэргийлэх </h4>
            <p class="depth">
                Хүүхэд алга болох, барьцаалагдахаас урьдчилан сэргийлэхийн тулд асран хамгаалагч хүүхэдтэйгээ үргэлж хамт байхыг хүсч байна. 
            </p>

            <h4 class="bullet02 type2 num4 depth">
                Өвчтөнд хэвийн бус шинж тэмдэг(ухамсарын өөрчлөлт, цээжээр өвдөх, цус алдах, таталт өгөх) илэрвэл нэн даруй эмнэлгийн ажилтан болон эмч нарт мэдэгдэнэ үү. 
            </h4>

            <h4 class="bullet02 type2 num5 depth">Өрөө шилжих</h4>
            <p class="depth">Адилхан зэрэглэлтэй өрөөнд өвчтөний аюулгүй байдлын асуудал(эм тариа хийх, цус авах, хоол тараах, эмчлэх зэрэг)-с болж хүссэн ор руу нь шилжүүлэхийг хориглоно. </p>
        </div>
        <div id="step2" class="step-item info">
            <h3 class="bullet01">Бэлдэх зүйлс</h3>
            <div class="need-item">
                <div class="need-item__text">
                    <h4 class="bullet02 type2 num1 depth">Хувийн бэлтгэл зүйлс</h4>
                    <p class="bullet03 depth font-main">Өвчтөний иргэний үнэмлэх (заавал)</p>
                    <p class="bullet05 depth"> Өөрийгөө таних - Гар утасны иргэний үнэмлэх болон эрүүл мэндийн даатгалын карт хүлээн авах боломжтой</p>
                    <p class="bullet05 depth"> Өвчтөн нь насанд хүрээгүй бол гэр бүлийн харилцааны баталгаажуулалт / гэр бүлийн бүртгэлийн хуулбар хэрэглэж болно</p>
                    <p class="bullet05 depth font-sub"> Иргэний эрүүл мэндийн даатгалын хууль "Өвчтөний өөрийгөө таних үүрэг" 2024 оны 5-р сарын 20-наас хэрэгжиж эхлэх</p>
                    <p class="bullet03 depth">Эмчилгээ: Одоогийн хэрэглэж байгаа эмийн жор эсвэл эмийн нэрийг бичсэн эмийн уутыг тасгийн сувилагчийн өрөөнд өгөх</p>
                    <p class="bullet03 depth">Бэлтгэл зүйлс: Ариун цэврийн хэрэгсэл, алчуур, өвчтөний хаалттай дотор гутал (слайпер, крокс хориотой), биеийн усаар арчих цаас, усны аяга, асрагчийн орны бүтээлэг болон бусад хувийн хэрэгсэл</p>
                    <h4 class="bullet02 type2 num2 depth">Бусад зүйлс</h4>
                    <p class="bullet03 depth">Хэрэв мэс засал төлөвлөсөн бол, хумсны арчилгааг заавал арилгах хэрэгтэй</p>
                    <p class="bullet03 depth">Бэлтгэл зүйлс: Ариун цэврийн хэрэгсэл, алчуур, өвчтөний хаалттай дотор гутал (слайпер, крокс хориотой), биеийн усаар арчих цаас, халдвар, гал түймэр, аюулгүй байдлын ослоос урьдчилан сэргийлэх үүднээс чийгшүүлэгч, цахилгаан ус буцалгагч, цахилгаан халаагуур, сэнс болон бусад халаагч болон дөлөөр галд орох чадвартай материалуудыг ашиглахыг хориглоно, асрагчийн орны бүтээлэг болон бусад хувийн хэрэгсэл</p>
                </div>
                <div class="need-item__img">
                    <img src="/resource/img/intensive--img01.png" alt="">
                </div>
            </div>
        </div>
        
        <div id="step3" class="step-item info">
            <h3 class="bullet01">Эмчийн үзлэг</h3>
            <p class="depth">Үдээс өмнө 8 цаг~10 цаг, үдээс хойш 5 цаг ~6 цагийн үед эмчийн үзлэгтэй бөгөөд эмчилгээний клиник тасгаас хамаарч өөрчлөгдөх боломжтой. </p>
        </div>
        <div id="step4" class="step-item info">
            <h3 class="bullet01">Хоолны заавар</h3>
            <p class="bullet04 num1 depth">
                Өглөөний хоол үдээс өмнө 7 цаг ~8 цаг, өдрийн хоол үдээс хойш 12 цаг ~1 цаг, оройн хоол үдээс хойш 6 цаг ~7 цагийн үед тараах бөгөөд, хувиараа худалдаж авах, хоолны газар хооллохыг өвчтөний эмчилгээ болон халдварт өвчнөөс урьдчилан сэргийлэх үүднээс хязгаарлалт хийхийг хүсч байна. 
            </p>
            <p class="bullet04 num2 depth">
                Хөргөгчинд хоол хадгалах : дарсан хоолноос бусад төрлийн хоолны хувьд хадгалах хугацаа урт болвол чанарын хувьд өөрчлөлт орох магадлалтай тул зөвхөн 24 цаг хадгална уу. 
            </p>
            <p class="bullet04 num3 depth">
                Өвчтөн хүсвэл даатгал ороогүй ‘тусгай хоол’-г сонгох боломжтой бөгөөд, энэ тохиолдолд зардалын хувьд бүрэн өөрөө хариуцна. 
            </p>
        </div>
        <div id="step5" class="step-item info">
            <h3 class="bullet01">Эргэлтийн заавар болон анхаарах зүйлс</h3>
            <p class="bullet04 num1 depth">
                Өвчтөн хурдан эдгэрэх, тайван байлгах, халдвараас урьдчилан сэргийлэхийн тулд 13-аас доош насны хүүхдийг халдварт өвчтэй өвчтөний өрөө болон эрчимт эмчилгээний тасагт эргэлтээр уулзуулах хориглоно. 
            </p>
            <p class="bullet04 num2 depth">
                Ханиад болон халдварт өвчтэй асран хамгаалагчийг өвчтөнтэй уулзуулахгүй бөгөөд хувийн нууц сахин хамгаалахыг хүсч буй үед эсвэл уулзахыг хүсэхгүй байгаа тохиолдолд сувилагчид мэдэгдэхийг хүсч байна. 
            </p>
            <p class="bullet04 num3 depth">
                Эргэлтээр ирсэн зочдыг хянахын тулд нэрсийн жагсаалтад нэрээ бичихийг хүсч байна. 
            </p>
            <p class="bullet04 num4 depth"><span class="font-main">Эргэлтээр ирэх боломжтой цаг </span></p>
            <p class="bullet05 depth">Ажлын өдөр 18:00 ~ 20:00 </p>
            <p class="bullet05 depth">Амралтын өдөр, бүх нийтийн амралтын өдөр 10:00 ~ 12:00, 18:00 ~ 20:00.</p>
            <p class="bullet05 depth">Эргэлтийн цаг нь 2 цагаас доошгүй байх бөгөөд, 20:00 цагаас хойш эргэлтээр ирэхгүй байхыг хүсье. </p>
        </div>
        <div id="step6" class="step-item info">
            <h3 class="bullet01">Бусад</h3>
            <h4 class="bullet02 type2 num1 depth">Үйлчилгээнийгазар</h4>
            <p class="depth">Тасаг : нийтийн бие засах өрөө, хог хаягдал угаах өрөө, шүршүүрийн өрөө, амралтын өрөө, автомат машин, ус цэвэршүүлэгч, бичил долгионы зуух(пэйж), олон зориулалтаар ашигладаг өрөө байгаа.  </p>
            <p class="depth">Эмнэлгийн төлбөр тооцооны машин, видео CD бүртгэлийн машин, хүнсний дэлгүүр, банк, кофе шоп, хоолны газар, нарийн боовны газар, эмнэлгийн хэрэгсэл, хүнгүй хүргэлтийн хайрцаг зэрэг байгаа. </p>

            <h4 class="bullet02 type2 num2 depth">Хог ангилан хаях</h4>
            <p class="depth">
                Хэрэглэсэн алкохолтой хөвөн болон шархны боолтыг эмнэлгийн зориулалтын хог хаягдалд ялган хаяхыг хүсч байна. 
            </p>

            <h4 class="bullet02 type2 num3 depth">Тамхи татахыг хориглоно</h4>
            <p class="depth">
                Эмнэлэг нь өвчтөнүүдийн эрүүл мэнд , гал түймрээус урьдчилан сэргийлэх үүднээс эмнэлгийн бүх хэсэгт тамхи татахыг хориглодог тул тамхи татахгүй байхыг хүсье. 
            </p>

            <h4 class="bullet02 type2 num4 depth">Гал түймрээс урьдчилан сэргийлэх, хариу арга хэмжээ авах арга </h4>
            <p class="depth">
                Өрөөнд зөөврийн газын плитка, сэнс, цахилгаан халаагуур ашиглах болон шатамхай материал, бодис оруулахыг хориглоно. Гал гарсан тохиолдолд сувилагчид нэн даруй мэдэгдэж, эмнэлгийн ажилтнуудын зааврын дагуу дайжих өрөө болон яаралтай үед ашиглах шатаар гарахыг хүсч байна. 
            </p>

            <h4 class="bullet02 type2 num5 depth">Салхинд гарах заавар </h4>
            <p class="depth">
                Барилгын гадагшаа салхинд гарахыг зарчмын хувьд хориглоно. Гэхдээ хариуцаж буй сувилагчийн зөвшөөрлөөр асран хамгаалагчтай хамт барилгын 4 давхарт байх цэцэрлэгт хүрээлэн, хойд хаалганы зүлгэн талбай руу салхилах боломжтой. Салхилах үед гар утсаа биедээ авч явах хэрэгтэй бөгөөд үдээс хойш 6 цагаас өмнө өрөө рүүгээ эргэн ирэх ёстой.  
            </p>

            <h4 class="bullet02 type2 num6 depth">Өргөдөл гомдол шийдэх </h4>
            <p class="depth">
                Эмнэлэгээр үйлчлүүлэх үед асуухыг хүссэн зүйл болон тав тухгүй байсан зүйлс, магтахыг хүссэн зүйлсээ 1 давхарын хэрэглэгчийн сэтгэл ханамжийн өрөөнд зочлох юмуу, утсаар, эмнэлгийн цахим хуудсаар дамжуулан үйлчлүүлэгчийн дуу хоолойгоо дамжуулах боломжтой. 
            </p>

            <h4 class="bullet02 type2 num7 depth">Машины зогсоолын төлбөр </h4>
            <p class="depth">Өрөөний самбарт бичсэн машины зогсоолын талаарх зааврыг харна уу. </p>

            <h4 class="bullet02 type2 num8 depth">Эд зүйлээ алга болгох, алдахаас сэргийлнэ үү </h4>
            <p class="depth">
                <span class="font-main">
                    Үнэт эдлэл болон бэлэн мөнгийг өрөөндөө хадгалалгүй, 
                </span>
                хиймэл шүд, сонсголын аппарат, нүдний шил, ленз зэрэг хэрэгсэлээ шинжилгээ өгөх, мэс засал, мэс ажилбарын үед тайлан авч 
                <span class="font-main">
                    хадгалахдаа анхаарна уу. Өөрийн анхаарал болгоомжгүй байдлаас болж эд зүйлсээ алдсан тохиолдолд эмнэлэгээс хариуцлага хүлээхгүй болно. 
                </span>
            </p>
            <div class="depth">
                <div class="bullet-wrap">
                    <span class="font-main">Хувийн эд зүйлсээ хянах     </span>
                    <!-- <ul class="bullet-list">
                        <li class="bullet-item">본인관리</li>
                        <li class="bullet-item">보호자관리</li>
                    </ul> -->
                </div>
                <p>Шинжилгээ өгөх, эмчилгээ хийлгэх үед эд зүйлсээ авах, тайлах үед алга болохоос сэргийлнэ үү. </p>
                <p>Өөрийн анхаарал болгоомжгүй байдлаас үүдэн алга болсон тохиолдолд эмнэлгээс хариуцлага хүлээхгүй болно. </p>

                <!-- <ul class="bullet-list type2">
                    <li class="bullet-item">틀니</li>
                    <li class="bullet-item">보청기</li>
                    <li class="bullet-item">안경</li>
                    <li class="bullet-item">시계</li>
                    <li class="bullet-item">귀걸이</li>
                    <li class="bullet-item">목걸이</li>
                    <li class="bullet-item">반지</li>
                    <li class="bullet-item">팔찌</li>
                    <li class="bullet-item">발찌</li>
                    <li class="bullet-item">열쇠</li>
                    <li class="bullet-item">지갑</li>
                    <li class="bullet-item">신발</li>
                    <li class="bullet-item">옷</li>
                    <li class="bullet-item">기타</li>
                    <li class="bullet-item">해당무</li>
                </ul> -->
            </div>


            <h4 class="bullet02 type2 num9 depth">Шашны байгууламж ашиглах заавар</h4>
            <p class="depth">
                Манай эмнэлэг нь Христчин эмнэлэг бөгөөд Эзэний өдрийн мөргөл ням гаригт үдээс өмнө 10 цаг, Лхагва гаригийн мөргөл лхагва гаригт үдээс хойш 5 цаг, хүүхэд/ өсвөрийн мөргөл нь пүрэв гаригт үдээс өмнө 10 цагт С байрны 3 давхарт Авдар цуглаант болно. Өрөөгөөр зочлох, итгэлийн амьдралын зөвлөгөө, бусад шашны талаарх зөвлөгөө авах талаар лавлахыг хүсвэл зөвлөгөө өгөх төв (02-6986-5724) рүү холбогдох боломжтой ба зөвлөгөө өгөх төв болон залбиралын өрөө нь С байрны 3 давхарт байрлана. 
            </p>

            <h4 class="bullet02 type2 num10 depth">Төрөл бүрийн баталгаажуулах материал гаргаж авах </h4>
            <p class="depth">
                Эмчийн магадлагаа, эмчилгээний бүртгэл болон бичлэгний хуулбар зэрэг шаардлагатай бичиг баримтаа хариуцаж буй эмч болон сувилагчид урьдчилан хэлнэ үү.  
            </p>

            <h4 class="bullet02 type2 num11 depth">Бүх эмчилгээний явцад өвчтөний эрх үүрэг хүндлэгдэн хамгаалагдана.</h4>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:40%;">
                            <col style="width:40%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Өвчтөний эрх </th>
                                <th>Өвчтөний үүрэг</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num1">Эмчилгээ хийлгэх эрх</p>
                                </td>
                                <td class="left" rowspan="2">
                                    <p class="bullet04 num1">Эмнэлгийн ажилтанд итгэх, хүндлэх үүрэг </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num2">Мэдэх эрх болон өөрөө шийдвэр гаргах эрх </p>
                                </td>
                            </tr>


                            <tr>
                                <td class="left">
                                    <p class="bullet04 num3">Нууцаа хамгаалуулах эрх</p>
                                </td>
                                <td class="left" rowspan="3">
                                    <p class="bullet04 num2">Хууль бус аргаар эмчлүүлэхгүй байх үүрэг </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num4">Зөвлөгөө авах·зохицуулалт хийх хүсэлт гаргах эрх </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num5">Аюулгүй эмчилгээний орчинд эмчилгээ үйлчилгээ авах эрх </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <h4 class="bullet02 type2 num12 depth mt30">Эмчилгээ хийхээс татгалзах заавар </h4>
            <p class="depth">
                Өвчтөн болон асран хамгаалагч нар нь тухайн эмнэлгийн ажилтаныг доромжилсон, нэр хүндэд нь халдсан, хүчирхийлсэн, ажил эрхлэхэд нь саад учруулсан зэрэг нөхцөл байдлыг бий болгож, эмнэлгийн ажилтан нь эмчилгээ үйлчилгээг хэвийн байдлаар хийх боломжгүй болсон тохиолдолд эмнэлгийн хууль болон яаралтай тусламж үйлчилгээний тухай хуулийн хүрээнд эмчилгээ хийхээс татгалзах(эмчилгээ хийхээс татгалзах эрх) боломжтой. 
            </p>
            <h4 class="bullet02 type2 num13 depth">
                Өвчтөн болон асран хамгаалагч(зочин) нь ажилтаныг хүчирхийлсэн(хэл амаар доромжлох, дарамтлах, танхайрах, бэлгийн хүчирхийлэл, бэлгийн дарамт, эд зүйл эвдлэх) үйлдэл гаргаж хохирол учруулсан тохиолдолд холбогдох хуулийн дагуу ял шийтгэл хүлээх боломжтой. 
            </h4>

        </div>

    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>